//引入路由组件
import { BrowserRouter } from 'react-router-dom'
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import LoginModal from './components/LoginModal';


// 1. 定义全局变量，防止代码报错 (放在所有逻辑最前面)
window._hmt = window._hmt || [];

// 2. 判断是否为生产环境，且是否配置了 ID
const baiduId = process.env.REACT_APP_BAIDU_ID;

if (process.env.NODE_ENV === 'production' && baiduId) {
  // 动态创建百度统计脚本
  const script = document.createElement('script');
  script.src = `https://hm.baidu.com/hm.js?${baiduId}`;
  script.async = true; // 异步加载，不影响页面渲染
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <LoginModal />
      <App />
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
